import { ActivityEnum } from '@api/enum';

export const acitivityColor = (activity: ActivityEnum) => {
    if (activity === ActivityEnum.HIGH) return 'success';
    if (activity === ActivityEnum.MEDIUM) return 'primary';
    if (activity === ActivityEnum.LOW) return 'warning';
    if (activity === ActivityEnum.NOT_AVAILABLE) return 'danger';
    if (activity === null || activity === undefined) return 'danger';
};
